let conceptos_sat = Object.freeze( [
    {
        "enumeration": [
            {
                "value": "002",
                
            },
            {
                "value": "006",
                
            },
            {
                "value": "009",
                
            },
            {
                "value": "012",
                
            },
            {
                "value": "014",
                
            },
            {
                "value": "019",
                
            },
            {
                "value": "021",
                
            },
            {
                "value": "030",
                
            },
            {
                "value": "032",
                
            },
            {
                "value": "036",
                
            },
            {
                "value": "037",
                
            },
            {
                "value": "042",
                
            },
            {
                "value": "044",
                
            },
            {
                "value": "058",
                
            },
            {
                "value": "059",
                
            },
            {
                "value": "060",
                
            },
            {
                "value": "062",
                
            },
            {
                "value": "072",
                
            },
            {
                "value": "102",
                
            },
            {
                "value": "103",
                
            },
            {
                "value": "106",
                
            },
            {
                "value": "108",
                
            },
            {
                "value": "110",
                
            },
            {
                "value": "112",
                
            },
            {
                "value": "113",
                
            },
            {
                "value": "116",
                
            },
            {
                "value": "124",
                
            },
            {
                "value": "126",
                
            },
            {
                "value": "127",
                
            },
            {
                "value": "128",
                
            },
            {
                "value": "129",
                
            },
            {
                "value": "130",
                
            },
            {
                "value": "131",
                
            },
            {
                "value": "132",
                
            },
            {
                "value": "133",
                
            },
            {
                "value": "134",
                
            },
            {
                "value": "135",
                
            },
            {
                "value": "136",
                
            },
            {
                "value": "137",
                
            },
            {
                "value": "138",
                
            },
            {
                "value": "139",
                
            },
            {
                "value": "140",
                
            },
            {
                "value": "141",
                
            },
            {
                "value": "143",
                
            },
            {
                "value": "145",
                
            },
            {
                "value": "147",
                
            },
            {
                "value": "148",
                
            },
            {
                "value": "149",
                
            },
            {
                "value": "150",
                
            },
            {
                "value": "151",
                
            },
            {
                "value": "152",
                
            },
            {
                "value": "153",
                
            },
            {
                "value": "154",
                
            },
            {
                "value": "155",
                
            },
            {
                "value": "156",
                
            },
            {
                "value": "157",
                
            },
            {
                "value": "158",
                
            },
            {
                "value": "159",
                
            },
            {
                "value": "160",
                
            },
            {
                "value": "166",
                
            },
            {
                "value": "168",
                
            },
            {
                "value": "600",
                
            },
            {
                "value": "601",
                
            },
            {
                "value": "602",
                
            },
            {
                "value": "605",
                
            },
            {
                "value": "606",
                
            },
            {
                "value": "607",
                
            },
            {
                "value": "608",
                
            },
            {
                "value": "610",
                
            },
            {
                "value": "614",
                
            },
            {
                "value": "615",
                
            },
            {
                "value": "616",
                
            },
            {
                "value": "617",
                
            },
            {
                "value": "618",
                
            },
            {
                "value": "619",
                
            },
            {
                "value": "620",
                
            },
            {
                "value": "621",
                
            },
            {
                "value": "622",
                
            },
            {
                "value": "623",
                
            },
            {
                "value": "626",
                
            },
            {
                "value": "627",
                
            },
            {
                "value": "628",
                
            },
            {
                "value": "629",
                
            },
            {
                "value": "630",
                
            },
            {
                "value": "631",
                
            },
            {
                "value": "632",
                
            },
            {
                "value": "633",
                
            },
            {
                "value": "634",
                
            },
            {
                "value": "636",
                
            },
            {
                "value": "637",
                
            },
            {
                "value": "638",
                
            },
            {
                "value": "640",
                
            },
            {
                "value": "642",
                
            },
            {
                "value": "646",
                
            },
            {
                "value": "647",
                
            },
            {
                "value": "648",
                
            },
            {
                "value": "649",
                
            },
            {
                "value": "651",
                
            },
            {
                "value": "652",
                
            },
            {
                "value": "653",
                
            },
            {
                "value": "655",
                
            },
            {
                "value": "656",
                
            },
            {
                "value": "659",
                
            },
            {
                "value": "670",
                
            },
            {
                "value": "901",
                
            },
            {
                "value": "902",
                
            }
        ],
        "value": "c_Banco",
        "text": "Banco",
    },
    {
        "enumeration": [
            {
                "value": "IP",
                
            },
            {
                "value": "IF",
                
            },
            {
                "value": "IM",
                
            }
        ],
        "value": "c_OrigenRecurso",
        "text": "Origen Recurso",
    },
    {
        "enumeration": [
            {
                "value": "01",
                
            },
            {
                "value": "02",
                
            },
            {
                "value": "03",
                
            },
            {
                "value": "04",
                
            },
            {
                "value": "05",
                
            },
            {
                "value": "06",
                
            },
            {
                "value": "07",
                
            },
            {
                "value": "08",
                
            },
            {
                "value": "09",
                
            },
            {
                "value": "10",
                
            },
            {
                "value": "99",
                
            }
        ],
        "value": "c_PeriodicidadPago",
        "text": "Periodicidad Pago",
    },
    {
        "enumeration": [
            {
                "value": "01",
                
            },
            {
                "value": "02",
                
            },
            {
                "value": "03",
                
            },
            {
                "value": "04",
                
            },
            {
                "value": "05",
                
            },
            {
                "value": "06",
                
            },
            {
                "value": "07",
                
            },
            {
                "value": "08",
                
            },
            {
                "value": "09",
                
            },
            {
                "value": "10",
                
            },
            {
                "value": "99",
                
            }
        ],
        "value": "c_TipoContrato",
        "text": "Tipo Contrato",
    },
    {
        "enumeration": [
            {"value": "001", "text":	"Seguridad social"},
            {"value": "002", "text":	"ISR"},
            {"value": "003", "text":	"Aportaciones a retiro, cesantía en edad avanzada y vejez."},
            {"value": "004", "text":	"Otros"},
            {"value": "005", "text":	"Aportaciones a Fondo de vivienda"},
            {"value": "006", "text":	"Descuento por incapacidad"},
            {"value": "007", "text":	"Pensión alimenticia"},
            {"value": "008", "text":	"Renta"},
            {"value": "009", "text":	"Préstamos provenientes del Fondo Nacional de la Vivienda para los Trabajadores"},
            {"value": "010", "text":	"Pago por crédito de vivienda"},
            {"value": "011", "text":	"Pago de abonos INFONACOT"},
            {"value": "012", "text":	"Anticipo de salarios"},
            {"value": "013", "text":	"Pagos hechos con exceso al trabajador"},
            {"value": "014", "text":	"Errores"},
            {"value": "015", "text":	"Pérdidas"},
            {"value": "016", "text":	"Averías"},
            {"value": "017", "text":	"Adquisición de artículos producidos por la empresa o establecimiento"},
            {"value": "018", "text":	"Cuotas para la constitución y fomento de sociedades cooperativas y de cajas de ahorro"},
            {"value": "019", "text":	"Cuotas sindicales"},
            {"value": "020", "text":	"Ausencia (Ausentismo)"},
            {"value": "021", "text":	"Cuotas obrero patronales"},
            {"value": "022", "text":	"Impuestos Locales"},
            {"value": "023", "text":	"Aportaciones voluntarias"},
            {"value": "024", "text":	"Ajuste en Gratificación Anual (Aguinaldo) Exento"},
            {"value": "025", "text":	"Ajuste en Gratificación Anual (Aguinaldo) Gravado"},
            {"value": "026", "text":	"Ajuste en Participación de los Trabajadores en las Utilidades PTU Exento"},
            {"value": "027", "text":	"Ajuste en Participación de los Trabajadores en las Utilidades PTU Gravado"},
            {"value": "028", "text":	"Ajuste en Reembolso de Gastos Médicos Dentales y Hospitalarios Exento"},
            {"value": "029", "text":	"Ajuste en Fondo de ahorro Exento"},
            {"value": "030", "text":	"Ajuste en Caja de ahorro Exento"},
            {"value": "031", "text":	"Ajuste en Contribuciones a Cargo del Trabajador Pagadas por el Patrón Exento"},
            {"value": "032", "text":	"Ajuste en Premios por puntualidad Gravado"},
            {"value": "033", "text":	"Ajuste en Prima de Seguro de vida Exento"},
            {"value": "034", "text":	"Ajuste en Seguro de Gastos Médicos Mayores Exento"},
            {"value": "035", "text":	"Ajuste en Cuotas Sindicales Pagadas por el Patrón Exento"},
            {"value": "036", "text":	"Ajuste en Subsidios por incapacidad Exento"},
            {"value": "037", "text":	"Ajuste en Becas para trabajadores y/o hijos Exento"},
            {"value": "038", "text":	"Ajuste en Horas extra Exento"},
            {"value": "039", "text":	"Ajuste en Horas extra Gravado"},
            {"value": "040", "text":	"Ajuste en Prima dominical Exento"},
            {"value": "041", "text":	"Ajuste en Prima dominical Gravado"},
            {"value": "042", "text":	"Ajuste en Prima vacacional Exento"},
            {"value": "043", "text":	"Ajuste en Prima vacacional Gravado"},
            {"value": "044", "text":	"Ajuste en Prima por antigüedad Exento"},
            {"value": "045", "text":	"Ajuste en Prima por antigüedad Gravado"},
            {"value": "046", "text":	"Ajuste en Pagos por separación Exento"},
            {"value": "047", "text":	"Ajuste en Pagos por separación Gravado"},
            {"value": "048", "text":	"Ajuste en Seguro de retiro Exento"},
            {"value": "049", "text":	"Ajuste en Indemnizaciones Exento"},
            {"value": "050", "text":	"Ajuste en Indemnizaciones Gravado"},
            {"value": "051", "text":	"Ajuste en Reembolso por funeral Exento"},
            {"value": "052", "text":	"Ajuste en Cuotas de seguridad social pagadas por el patrón Exento"},
            {"value": "053", "text":	"Ajuste en Comisiones Gravado"},
            {"value": "054", "text":	"Ajuste en Vales de despensa Exento"},
            {"value": "055", "text":	"Ajuste en Vales de restaurante Exento"},
            {"value": "056", "text":	"Ajuste en Vales de gasolina Exento"},
            {"value": "057", "text":	"Ajuste en Vales de ropa Exento"},
            {"value": "058", "text":	"Ajuste en Ayuda para renta Exento"},
            {"value": "059", "text":	"Ajuste en Ayuda para artículos escolares Exento"},
            {"value": "060", "text":	"Ajuste en Ayuda para anteojos Exento"},
            {"value": "061", "text":	"Ajuste en Ayuda para transporte Exento"},
            {"value": "062", "text":	"Ajuste en Ayuda para gastos de funeral Exento"},
            {"value": "063", "text":	"Ajuste en Otros ingresos por salarios Exento"},
            {"value": "064", "text":	"Ajuste en Otros ingresos por salarios Gravado"},
            {"value": "065", "text":	"Ajuste en Jubilaciones, pensiones o haberes de retiro en una sola exhibición Exento "},
            {"value": "066", "text":	"Ajuste en Jubilaciones, pensiones o haberes de retiro en una sola exhibición Gravado"},
            {"value": "067", "text":	"Ajuste en Pagos por separación Acumulable"},
            {"value": "068", "text":	"Ajuste en Pagos por separación No acumulable"},
            {"value": "069", "text":	"Ajuste en Jubilaciones, pensiones o haberes de retiro en parcialidades Exento"},
            {"value": "070", "text":	"Ajuste en Jubilaciones, pensiones o haberes de retiro en parcialidades Gravado"},
            {"value": "071", "text":	"Ajuste en Subsidio para el empleo (efectivamente entregado al trabajador)"},
            {"value": "072", "text":	"Ajuste en Ingresos en acciones o títulos valor que representan bienes Exento"},
            {"value": "073", "text":	"Ajuste en Ingresos en acciones o títulos valor que representan bienes Gravado"},
            {"value": "074", "text":	"Ajuste en Alimentación Exento"},
            {"value": "075", "text":	"Ajuste en Alimentación Gravado"},
            {"value": "076", "text":	"Ajuste en Habitación Exento"},
            {"value": "077", "text":	"Ajuste en Habitación Gravado"},
            {"value": "078", "text":	"Ajuste en Premios por asistencia"},
            {"value": "079", "text":	"Ajuste en Pagos distintos a los listados y que no deben considerarse como ingreso por sueldos, salarios o ingresos asimilados."},
            {"value": "080", "text":	"Ajuste en Viáticos gravados"},
            {"value": "081", "text":	"Ajuste en Viáticos (entregados al trabajador)"},
            {"value": "082", "text":	"Ajuste en Fondo de ahorro Gravado"},
            {"value": "083", "text":	"Ajuste en Caja de ahorro Gravado"},
            {"value": "084", "text":	"Ajuste en Prima de Seguro de vida Gravado"},
            {"value": "085", "text":	"Ajuste en Seguro de Gastos Médicos Mayores Gravado"},
            {"value": "086", "text":	"Ajuste en Subsidios por incapacidad Gravado"},
            {"value": "087", "text":	"Ajuste en Becas para trabajadores y/o hijos Gravado"},
            {"value": "088", "text":	"Ajuste en Seguro de retiro Gravado"},
            {"value": "089", "text":	"Ajuste en Vales de despensa Gravado"},
            {"value": "090", "text":	"Ajuste en Vales de restaurante Gravado"},
            {"value": "091", "text":	"Ajuste en Vales de gasolina Gravado"},
            {"value": "092", "text":	"Ajuste en Vales de ropa Gravado"},
            {"value": "093", "text":	"Ajuste en Ayuda para renta Gravado"},
            {"value": "094", "text":	"Ajuste en Ayuda para artículos escolares Gravado"},
            {"value": "095", "text":	"Ajuste en Ayuda para anteojos Gravado"},
            {"value": "096", "text":	"Ajuste en Ayuda para transporte Gravado"},
            {"value": "097", "text":	"Ajuste en Ayuda para gastos de funeral Gravado"},
            {"value": "098", "text":	"Ajuste a ingresos asimilados a salarios gravados"},
            {"value": "099", "text":	"Ajuste a ingresos por sueldos y salarios gravados"},
            {"value": "100", "text":	"Ajuste en Viáticos exentos"},
            {"value": "101", "text":	"ISR Retenido de ejercicio anterior"},
            {"value": "102", "text":	"Ajuste a pagos por gratificaciones, primas, compensaciones, recompensas u otros a extrabajadores derivados de jubilación en parcialidades, gravados"},
            {"value": "103", "text":	"Ajuste a pagos que se realicen a extrabajadores que obtengan una jubilación en parcialidades derivados de la ejecución de una resolución judicial o de un laudo gravados"},
            {"value": "104", "text":	"Ajuste a pagos que se realicen a extrabajadores que obtengan una jubilación en parcialidades derivados de la ejecución de una resolución judicial o de un laudo exentos"},
            {"value": "105", "text":	"Ajuste a pagos que se realicen a extrabajadores que obtengan una jubilación en una sola exhibición derivados de la ejecución de una resolución judicial o de un laudo gravados"},
            {"value": "106", "text":	"Ajuste a pagos que se realicen a extrabajadores que obtengan una jubilación en una sola exhibición derivados de la ejecución de una resolución judicial o de un laudo exentos"},
            {"value": "107", "text":	"Ajuste al Subsidio Causado "},
            {"value": "108", "text":	"Ajuste a días de descanso laborados gravados"},
            {"value": "109", "text":	"Ajuste a días de descanso laborados exentos"},
            {"value": "110", "text":	"Ajuste a días de descanso obligatorios laborados gravados"},
            {"value": "111", "text":	"Ajuste a días de descanso obligatorios laborados exentos"},
        ],
        "value": "c_TipoDeduccion",
        "text": "Tipo Deducción",
    },
    {
        "enumeration": [
            {
                "value": "01",
                
            },
            {
                "value": "02",
                
            },
            {
                "value": "03",
                
            }
        ],
        "value": "c_TipoHoras",
        "text": "Tipo Horas",
    },
    {
        "enumeration": [
            {
                "value": "01",
                
            },
            {
                "value": "02",
                
            },
            {
                "value": "03",
                
            }
        ],
        "value": "c_TipoIncapacidad",
        "text": "Tipo Incapacidad",
    },
    {
        "enumeration": [
            {
                "value": "02",
                
            },
            {
                "value": "03",
                
            },
            {
                "value": "01",
                
            },
            {
                "value": "04",
                
            },
            {
                "value": "05",
                
            },
            {
                "value": "06",
                
            },
            {
                "value": "07",
                
            },
            {
                "value": "08",
                
            },
            {
                "value": "99",
                
            }
        ],
        "value": "c_TipoJornada",
        "text": "Tipo Jornada",
    },
    {
        "enumeration": [
            {
                "value": "O",
                "text": "Nómina ordinaria",
            },
            {
                "value": "E",
                "text": "Nómina extraordinaria",
            }
        ],
        "value": "c_TipoNomina",
        "text": "Tipo Nomina",
    },
    {
        "enumeration": [
            {"value": "001", "text":	"Reintegro de ISR pagado en exceso (siempre que no haya sido enterado al SAT)."},
            {"value": "002", "text":	"Subsidio para el empleo (efectivamente entregado al trabajador)."},
            {"value": "003", "text":	"Viáticos (entregados al trabajador)."},
            {"value": "004", "text":	"Aplicación de saldo a favor por compensación anual."},
            {"value": "005", "text":	"Reintegro de ISR retenido en exceso de ejercicio anterior (siempre que no haya sido enterado al SAT)."},
            {"value": "006", "text":	"Alimentos en bienes (Servicios de comedor y comida) Art 94 último párrafo LISR."},
            {"value": "007", "text":	"ISR ajustado por subsidio."},
            {"value": "008", "text":	"Subsidio efectivamente entregado que no correspondía (Aplica sólo cuando haya ajuste al cierre de mes en relación con el Apéndice 7 de la guía de llenado de nómina)."},
            {"value": "009", "text":	"Reembolso de descuentos efectuados para el crédito de vivienda."},
            {"value": "999", "text":	"Pagos distintos a los listados y que no deben considerarse como ingreso por sueldos, salarios o ingresos asimilados."},
        ],
        "value": "c_TipoOtroPago",
        "text": "Tipo Otro Pago",
    },
    {
        "enumeration": [
            {"value": "001", "text": "Sueldos, Salarios  Rayas y Jornales"},
            {"value": "002", "text": "Gratificación Anual (Aguinaldo)"},
            {"value": "003", "text": "Participación de los Trabajadores en las Utilidades PTU"},
            {"value": "004", "text": "Reembolso de Gastos Médicos Dentales y Hospitalarios"},
            {"value": "005", "text": "Fondo de Ahorro"},
            {"value": "006", "text": "Caja de ahorro"},
            {"value": "009", "text": "Contribuciones a Cargo del Trabajador Pagadas por el Patrón"},
            {"value": "010", "text": "Premios por puntualidad"},
            {"value": "011", "text": "Prima de Seguro de vida"},
            {"value": "012", "text": "Seguro de Gastos Médicos Mayores"},
            {"value": "013", "text": "Cuotas Sindicales Pagadas por el Patrón"},
            {"value": "014", "text": "Subsidios por incapacidad"},
            {"value": "015", "text": "Becas para trabajadores y/o hijos"},
            {"value": "019", "text": "Horas extra"},
            {"value": "020", "text": "Prima dominical"},
            {"value": "021", "text": "Prima vacacional"},
            {"value": "022", "text": "Prima por antigüedad"},
            {"value": "023", "text": "Pagos por separación"},
            {"value": "024", "text": "Seguro de retiro"},
            {"value": "025", "text": "Indemnizaciones"},
            {"value": "026", "text": "Reembolso por funeral"},
            {"value": "027", "text": "Cuotas de seguridad social pagadas por el patrón"},
            {"value": "028", "text": "Comisiones"},
            {"value": "029", "text": "Vales de despensa"},
            {"value": "030", "text": "Vales de restaurante"},
            {"value": "031", "text": "Vales de gasolina"},
            {"value": "032", "text": "Vales de ropa"},
            {"value": "033", "text": "Ayuda para renta"},
            {"value": "034", "text": "Ayuda para artículos escolares"},
            {"value": "035", "text": "Ayuda para anteojos"},
            {"value": "036", "text": "Ayuda para transporte"},
            {"value": "037", "text": "Ayuda para gastos de funeral"},
            {"value": "038", "text": "Otros ingresos por salarios"},
            {"value": "039", "text": "Jubilaciones, pensiones o haberes de retiro"},
            {"value": "044", "text": "Jubilaciones, pensiones o haberes de retiro en parcialidades"},
            {"value": "045", "text": "Ingresos en acciones o títulos valor que representan bienes"},
            {"value": "046", "text": "Ingresos asimilados a salarios"},
            {"value": "047", "text": "Alimentación diferentes a los establecidos en el Art 94 último párrafo LISR"},
            {"value": "048", "text": "Habitación"},
            {"value": "049", "text": "Premios por asistencia"},
            {"value": "050", "text": "Viáticos"},
            {"value": "051", "text": "Pagos por gratificaciones, primas, compensaciones, recompensas u otros a extrabajadores derivados de jubilación en parcialidades"},
            {"value": "052", "text": "Pagos que se realicen a extrabajadores que obtengan una jubilación en parcialidades derivados de la ejecución de resoluciones judicial o de un laudo"},
            {"value": "053", "text": "Pagos que se realicen a extrabajadores que obtengan una jubilación en una sola exhibición derivados de la ejecución de resoluciones judicial o de un laudo"},
            {"value": "054", "text": "Dias descanso laborado"},
            {"value": "055", "text": "Dias de descanso obligatorios laborados"},
        ],
        "value": "c_TipoPercepcion",
        "text": "Tipo Percepción",
    },
    {
        "enumeration": [
            {
                "value": "03",
                
            },
            {
                "value": "02",
                
            },
            {
                "value": "04",
                
            },
            {
                "value": "05",
                
            },
            {
                "value": "06",
                
            },
            {
                "value": "07",
                
            },
            {
                "value": "08",
                
            },
            {
                "value": "09",
                
            },
            {
                "value": "10",
                
            },
            {
                "value": "11",
                
            },
            {
                "value": "12",
                
            },
            {
                "value": "13",
                
            },
            {
                "value": "99",
                
            }
        ],
        "value": "c_TipoRegimen",
        "text": "Tipo Regimen",
    },
    {
        "enumeration": [
            {
                "value": "1",
                
            },
            {
                "value": "2",
                
            },
            {
                "value": "3",
                
            },
            {
                "value": "4",
                
            },
            {
                "value": "5",
                
            },
            {
                "value": "99",
                
            }
        ],
        "value": "c_RiesgoPuesto",
        "text": "Riesgo Puesto",
    }
],);
//0 – c_tipodeduccion, 1 – c_tipopercepcion, 2 -- c_otropago
module.exports = { conceptos_sat }
  